import { CourseId, JournalId, LessonDTO, LessonFormFields } from 'types';
import { parseStringIntoDayjsDate } from 'utils/parsers/dateTime/parseStringIntoDayjsDate';
import { parseStringIntoDayjsTime } from 'utils/parsers/dateTime/parseStringIntoDayjsTime';

export const parseLessonDTOIntoLessonFormFields = (lessonDTO: LessonDTO): LessonFormFields => {
    const teacherIds = lessonDTO.teachers?.map((teacher) => teacher.id) || [];

    return {
        journalId: lessonDTO.journal?.id ?? ('' as JournalId),
        teacherIds,
        courseId: (lessonDTO.course?.id || lessonDTO.courseId) as CourseId,
        name: lessonDTO.course?.id || lessonDTO.name,
        timeFrom: parseStringIntoDayjsTime(lessonDTO.timeFrom),
        timeTo: parseStringIntoDayjsTime(lessonDTO.timeTo),
        childIds: lessonDTO.children.map((child) => child.id),
        startDate: parseStringIntoDayjsDate(lessonDTO.startDate),
        finishDate: parseStringIntoDayjsDate(lessonDTO.endDate),
        repetition: lessonDTO.repetition,
        journalName: lessonDTO.journal?.name ?? '',
    };
};
